module.exports = __webpack_public_path__ + "static/Icons_homeloans_active_large-7cae07c5a919f5fb3f7aa887ea2a7262.png";